import styled from 'styled-components';

export const AboutVideoBox = styled.div`
  min-width: 610px;
  width: 100%;
  height: 445px;
  background-color: ${(props) => props.theme.colors.lightGray};
  border-radius: ${(props) => props.theme.borderRadius.xs}px;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 5px 40px rgba(0, 0, 0, 0.1);

  @media (max-width: 1130px) {
    min-width: calc(610px - (1130px - 100vw));
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    height: calc(243 / 390 * 100vw);
    max-height: 445px;
  }
`;

export const AboutProgressBar = styled.div`
  margin: calc(10 / 610 * 100%);
  position: absolute;
  width: calc(100% - 20px);
  height: 4px;
  background-color: ${(props) => props.theme.colors.videoBgGray};
  border-radius: ${(props) => props.theme.borderRadius.xs}px;
`;

export const CurrentProgress = styled.div`
  height: 100%;
  background-color: ${(props) => props.theme.colors.blue};
  border-radius: ${(props) => props.theme.borderRadius.xs}px;
  transition: 0.1s all linear;
`;

export const AboutVideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
`;

interface TemplatesColoredVideo {
  $bgColor?: string;
  $visible?: boolean;
}

export const TemplatesVideoContainer = styled.div`
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    width: 100%;
  }
`;

export const TemplatesColoredVideo = styled.div<TemplatesColoredVideo>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 540px;
  height: 650px;
  border-radius: 14px;
  background-color: ${(props: TemplatesColoredVideo) => props.$bgColor};

  @media (max-width: 1200px) {
    width: calc(540px - (1200px - 100vw));
    min-width: 350px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    width: 100%;
    height: 402px;
    min-width: 0px;
  }
`;

export const TemplatesVideoBox = styled.div`
  width: 260px;
  height: 570px;
  border-radius: 30px;
  border: #e1e1e1 solid 10px;
  box-sizing: content-box;
  overflow: hidden;
  position: relative;

  & > svg {
    width: 280px;
    height: 590px;
    position: absolute;
    top: -10px;
    left: -10px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    width: 157px;
    height: 325px;

    & > svg {
      width: 177px;
      height: 345px;
    }
  }
`;

export const TemplatesVideoElement = styled.video`
  width: 260px;
  height: 570px;
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 20px;
  object-fit: cover;
  object-position: center top;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    width: 157px;
    height: 325px;
  }
`;

export const TemplatesProgressBar = styled.div`
  position: absolute;
  top: 15px;
  width: calc(100% - 30px);
  height: 4px;
  background-color: ${(props) => props.theme.colors.videoBgGray};
  border-radius: ${(props) => props.theme.borderRadius.xs}px;
`;

export const PlayStopBox = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  z-index: 1;
`;

export const PlayButton = styled.img``;

export const StopButton = styled.img``;
